<mat-form-field
  [hideRequiredMarker]="true"
  [floatLabel]="to.floatLabel"
  [appearance]="to.appearance"
  [color]="to.color"
  [style.width]="'100%'">
  <mat-label *ngIf="to.label && to.hideLabel !== true" color="warn">
    {{ to.label }}
    <span *ngIf="to.required && to.hideRequiredMarker !== true" class="mat-form-field-required-marker">* <span class="required">(required)</span></span>
  </mat-label>
  <!--<input matInput [formControl]="formControl" [formlyAttributes]="field"> -->
  <input matInput hidden>
  <ng-container #fieldComponent></ng-container>
</mat-form-field>
